import {Image} from "@mui/icons-material";
import QueriesList from "./QueriesList";

export default {
    list: QueriesList,
    // edit: DoubtEdit,
    icon: Image,
};
